import React from "react";
import styles from "./OpenMenuBlock.module.scss";
import { usePopup } from "@/context/PopupContext";

const OpenMenuBlock: React.FC = () => {
  const { openMenu } = usePopup();
  return (
    <div className="container">
      <div className={`${styles.openMenuBlock} sideP88`}>
        <div className={styles.textContent}>
          <h2>Jetzt Reparatur-Service anfragen</h2>
          <p>
            Profitieren Sie von unseren schnellen und zuverlässigen
            Dienstleistungen.
          </p>
        </div>
        <button
          className={`${styles.button} commonButton buttonXl`}
          onClick={openMenu}
        >
          Jetzt anfragen
        </button>
        <img className={styles.bgImg} src="/images/deco-bg.svg" alt="hixa" />
      </div>
    </div>
  );
};

export default OpenMenuBlock;
